import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "explainBlock" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: "/images/GoogleHomeApp.JPG" }, null, -1)
const _hoisted_3 = { class: "explainBlock" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", null, "What's this?", -1)
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "explainBlock" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", null, "Demo", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"explainBlock\"><h1>Development</h1><div>Programming Language</div><ul><li>HTML</li><li>JavaScript</li></ul><div>Platform&amp;Others</div><ul><li>Google Home mini</li><li>Google Apps Script</li><li>Google Cloud Functions(Google Cloud Platform)</li><li>Dialogflow</li></ul></div><div class=\"explainBlock\"><h1>Created Day</h1><div>2018/5</div></div><div class=\"explainBlock\"><h1>More Details</h1><ul><li><a href=\"https://ikep.hatenablog.com/entry/2018/05/21/121552\">My blog 1</a></li><li><a href=\"https://ikep.hatenablog.com/entry/2018/06/12/165602\">My blog 2</a></li></ul></div>", 3)

import Tweet from "vue-tweet";
import routerPath from "../../routerPath";

export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleHomeApp',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t("message.GoogleHomeApp")), 1),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("message.GoogleHomeAppWhat1")), 1),
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("message.GoogleHomeAppWhat2")), 1),
      _createElementVNode("div", null, _toDisplayString(_ctx.$t("message.GoogleHomeAppWhat3")), 1),
      _createElementVNode("a", {
        href: _unref(routerPath).routerPath('/products/cameraSystem')
      }, _toDisplayString(_ctx.$t("message.GoogleHomeAppWhat4")), 9, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode(_unref(Tweet), { "tweet-id": "1000769895297007616" }),
      _hoisted_8,
      _createVNode(_unref(Tweet), { "tweet-id": "1007277592049676288" })
    ]),
    _hoisted_9
  ], 64))
}
}

})